import { render, staticRenderFns } from "./Corporatevideos.vue?vue&type=template&id=90405ea0&scoped=true&"
import script from "./Corporatevideos.vue?vue&type=script&lang=js&"
export * from "./Corporatevideos.vue?vue&type=script&lang=js&"
import style0 from "./Corporatevideos.vue?vue&type=style&index=0&id=90405ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90405ea0",
  null
  
)

export default component.exports